import React, {Component, Suspense} from "react";
import {connect} from "react-redux";

import Intro from "./scenes/Intro";
import License from "../containers/scenes/License";
import Incompatible from "../containers/scenes/Incompatible";
import Login from "./scenes/Login";

const Redlike = React.lazy(() => import("../containers/apps/default/DefaultApp"));
const RedlikeLight = React.lazy(() => import("../containers/apps/light/LightApp"));
const Gamma = React.lazy(() => import("../containers/apps/gamma/GammaApp"));
const Coloris = React.lazy(() => import("../containers/apps/coloris/ColorisApp"));
const Setup = React.lazy(() => import("../containers/apps/setup/SetupApp"));

class Router extends Component {
    getSoftwareComponent = () => {
        if (this.props.gammaSoftware) {
            return (
                <Suspense fallback={<Intro />}>
                    <Gamma />
                </Suspense>
            );
        }

        if (this.props.redlikeLightSoftware) {
            return (
                <Suspense fallback={<Intro />}>
                    <RedlikeLight />
                </Suspense>
            );
        }

        if (this.props.colorisSoftware) {
            return (
                <Suspense fallback={<Intro />}>
                    <Coloris />
                </Suspense>
            );
        }

        return (
            <Suspense fallback={<Intro />}>
                <Redlike />
            </Suspense>
        );
    };

    render() {
        if (this.props.setupSoftware) {
            return (
                <Suspense fallback={<Intro />}>
                    <Setup />
                </Suspense>
            );
        }

        if (!this.props.licensed) {
            return <License />;
        }

        if (!this.props.compatible || !this.props.compatibleDatabase || !this.props.availableDatabase) {
            return <Incompatible />;
        }

        if (this.props.loggedIn) {
            return this.getSoftwareComponent();
        }

        return <Login />;
    }
}

export default Router = connect((store) => {
    return {
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        gammaSoftware: store.module.gammaSoftware,
        colorisSoftware: store.module.colorisSoftware,
        setupSoftware: store.module.setupSoftware,
        licensed: store.license.licensed,
        compatible: store.server.compatible,
        availableDatabase: store.server.availableDatabase,
        compatibleDatabase: store.server.compatibleDatabase,
        loggedIn: store.login.loggedIn
    };
})(Router);
